import constants from "../constants";
import h from "../services/h";
import vbOutgoingDocReceiversService from "../services/vbOutgoingDocReceiversService";
import utils from "../services/utils";
import outgoingDocService from "../services/outgoingDocService";
import departmentService from "../services/departmentService";
import incomingDocService from "../services/incomingDocService";

export default {
  data() {
    return {
      doc: null,
      root: null,
      vbIncomingDocs: null,
      departments: null,
      isRender: false,
      docReceivers: null,
      docReceiverOthers: null,
      selectedNode: null,
      PROCESS_TREE: constants.PROCESS_TREE
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    }
  },

  methods: {
    getProcessTypeByDeptId(deptId) {
      let docReceiver = h.find(
        this.docReceivers,
        item => item.objectId === deptId
      );
      return docReceiver ? docReceiver.receiveType : null;
    },

    loadDocReceivers() {
      return vbOutgoingDocReceiversService
        .findAll({docId: this.docId})
        .then(response => {
          let docReceivers = response.data;
          this.docReceivers = h.findAll(
            docReceivers,
            docReceiver =>
              docReceiver.objectType === constants.RECEIVER_OBJECT_TYPE.DONVI
          );
          this.docReceiverOthers = h.findAll(
            docReceivers,
            docReceiver =>
              docReceiver.objectType !== constants.RECEIVER_OBJECT_TYPE.DONVI
          );
        });
    },

    buildShortName(fullName) {
      return utils.buildShortName(fullName);
    },

    loadDoc() {
      return outgoingDocService
        .findById(this.docId)
        .then(response => {
          this.doc = response.data;
        });
    },

    loadBanHanhDepartments() {
      let toDeptIds = [];
      h.each(
        this.vbIncomingDocs,
        vbIncomingDoc => vbIncomingDoc.toDeptId && toDeptIds.push(vbIncomingDoc.toDeptId)
      );
      return !toDeptIds || !toDeptIds.length
        ? Promise.resolve([])
        : departmentService
          .findAllByIdIn(toDeptIds)
          .then(response => (this.departments = response.data));
    },

    loadClonedVbIncomingDocs() {
      return incomingDocService
        .findAllByVbOutgoingDocId(this.docId)
        .then(response => (this.vbIncomingDocs = response.data));
    },

    buildTreeDataForBanHanhNodes() {
      let treeNode = {
        id: constants.PROCESS_TREE.NODE_TYPE.BANHANH_NODE,
        expand: true,
        type: constants.PROCESS_TREE.NODE_TYPE.BANHANH_NODE
      };
      treeNode.children = [];
      treeNode.children.push(
        ...h.collect(this.vbIncomingDocs, vbIncomingDoc =>
          this.buildDonViBanHanhNode({}, vbIncomingDoc)
        )
      );
      treeNode.children.push(
        ...h.collect(this.docReceiverOthers, docReceiverOther =>
          this.buildDonViBanHanhNgoaiNode({}, docReceiverOther)
        )
      );
      return treeNode;
    },

    buildTreeDataForChoBanHanhNode() {
      return {
        id: constants.PROCESS_TREE.NODE_TYPE.CHOBANHANH_NODE,
        expand: true,
        type: constants.PROCESS_TREE.NODE_TYPE.CHOBANHANH_NODE
      };
    },

    buildDonViBanHanhNgoaiNode(treeNode, docReceiverOther) {
      treeNode.id = docReceiverOther.id;
      treeNode.expand = true;
      treeNode.docReceiverOther = docReceiverOther;
      treeNode.type = constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANHNGOAI_NODE;
      if (
        docReceiverOther.receiveStatus ===
        constants.VB_OUTGOING_DOC_RECEIVERS.RECEIVE_STATUS.TU_CHOI_TIEP_NHAN
      ) {
        treeNode.children = [this.buildTuChoiTiepNhanNode()];
      }
      return treeNode;
    },

    buildDonViBanHanhNode(treeNode, vbIncomingDoc) {
      treeNode.id = vbIncomingDoc.id;
      treeNode.expand = true;
      treeNode.vbIncomingDoc = vbIncomingDoc;
      treeNode.type = constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANH_NODE;
      if (
        vbIncomingDoc.status === constants.INCOMING_DOC_STATUS.TU_CHOI_TIEP_NHAN
      ) {
        treeNode.children = [this.buildTuChoiTiepNhanNode()];
      }
      return treeNode;
    },

    buildTuChoiTiepNhanNode() {
      return {
        id: constants.PROCESS_TREE.NODE_TYPE.TUCHOITIEPNHAN_NODE,
        expand: false,
        type: constants.PROCESS_TREE.NODE_TYPE.TUCHOITIEPNHAN_NODE
      };
    },

    buildTreeDataForTuChoiNodes() {
      return {
        id: constants.PROCESS_TREE.NODE_TYPE.TUCHOI_NODE,
        expand: false,
        type: constants.PROCESS_TREE.NODE_TYPE.TUCHOI_NODE
      };
    },

    buildTreeDataForTuChoiBHanhNodes() {
      return {
        id: constants.PROCESS_TREE.NODE_TYPE.TUCHOIBANHANH_NODE,
        expand: true,
        type: constants.PROCESS_TREE.NODE_TYPE.TUCHOIBANHANH_NODE
      };
    },

    renderBanHanhNode(h, data) {
      return h("div", {class: "node_label"}, [
        h("span", {class: "color__blue"}, "Ban Hành")
      ]);
    },

    renderChoBanHanhNode(h, data) {
      return h("div", {class: "node_label"}, [
        h("span", {class: "color__yellow"}, "Chờ ban hành")
      ]);
    },

    renderTuChoiNode(h, data) {
      let label = "-";
      switch (data.type) {
        case constants.PROCESS_TREE.NODE_TYPE.TUCHOIBANHANH_NODE:
          label = "Từ chối ban hành";
          break;
        case constants.PROCESS_TREE.NODE_TYPE.TUCHOI_NODE:
          label = "Từ chối";
          break;
        case constants.PROCESS_TREE.NODE_TYPE.TUCHOITIEPNHAN_NODE:
          label = "Từ chối tiếp nhận";
          break;
      }
      return h("div", {class: "node_label flex-row flex__center"}, [
        h("i", {class: "fas fa-reply color__red"}),
        h("span", {class: "no_wrap"}, "  " + label)
      ]);
    },

    renderDonViBanHanhNgoaiNode(h, data) {
      let docReceiverOther = data.docReceiverOther;
      let toDeptName = docReceiverOther.objectName;
      let isRead =
        docReceiverOther.receiveStatus &&
        (docReceiverOther.receiveStatus !==
          constants.VB_OUTGOING_DOC_RECEIVERS.RECEIVE_STATUS.CHO_PHAN_HOI &&
          docReceiverOther.receiveStatus !==
          constants.VB_OUTGOING_DOC_RECEIVERS.RECEIVE_STATUS.DA_DEN);
      let classes = ["node_handlder flex-row flex__center"];
      let components = [];
      components.push(
        h("div", {class: "flex-col flex__center"}, [
          h("div", {class: "profileIsRead"}, [
            h("div", {class: "avatar_fake flex-row flex__center"}, [
              h("span", this.buildShortName(toDeptName))
            ]),
            isRead
              ? h("i", {
                class:
                  "far fa-check-circle font-size__medium icon-read border-radius__50"
              })
              : null
          ]),
          h("div", {class: "info"}, [
            h("div", {class: "name no_wrap"}, toDeptName)
          ])
        ])
      );
      return h("div", {class: classes.join(" ")}, components);
    },

    renderDonViBanHanhNode(h, data) {
      let vbIncomingDoc = data.vbIncomingDoc;
      let toDeptName = vbIncomingDoc.toDeptName;
      let isRead =
        vbIncomingDoc.status !== constants.INCOMING_DOC_STATUS.TAO_MOI;
      let classes = ["node_handlder flex-row flex__center"];
      let components = [];
      let typeClassTag;
      let processType = this.getProcessTypeByDeptId(vbIncomingDoc.toDeptId);
      let processTypeLabel;
      switch (processType) {
        case constants.PROCESS_TYPE.CHUTRI:
          typeClassTag = "tag-chuTri";
          processTypeLabel = "Chủ trì";
          break;
        case constants.PROCESS_TYPE.PHOIHOP:
          typeClassTag = "tag-phoiHop";
          processTypeLabel = "Phối hợp";
          break;
        case constants.PROCESS_TYPE.NHANDEBIET:
          typeClassTag = "tag-nhanDeBiet";
          processTypeLabel = "Nhận để biết";
          break;
      }
      components.push(
        h("div", {class: "flex-col flex__center"}, [
          h("div", {class: "profileIsRead"}, [
            h("div", {class: "avatar_fake flex-row flex__center"}, [
              h("span", this.buildShortName(toDeptName))
            ]),
            isRead
              ? h("i", {
                class:
                  "far fa-check-circle font-size__medium icon-read border-radius__50"
              })
              : null
          ]),
          h("div", {class: "info"}, [
            h("div", {class: "name no_wrap"}, toDeptName)
            // h("div", {class: "more-info font-size__small"}, data.moreInfo)
          ]),
          typeClassTag
            ? h("div", {class: `tag ${typeClassTag}`}, processTypeLabel)
            : null
        ])
      );
      return h("div", {class: classes.join(" ")}, components);
    },

    onExpand(data) {
      if ("expand" in data) {
        data.expand = !data.expand;
        this.isRender = false;
        if (!data.expand && data.children) {
          this.collapse(data.children);
          this.$nextTick(() => {
            this.isRender = true;
          });
        }
      } else {
        this.$set(data, "expand", true);
        this.$nextTick(() => {
          this.isRender = true;
        });
      }
      this.$nextTick(() => {
        this.isRender = true;
      });
    },

    collapse(list) {
      let _this = this;
      list.forEach(child => {
        if (child.expand) {
          child.expand = false;
        }
        child.children && _this.collapse(child.children);
      });
    },

    toggleExpand(data, val) {
      let _this = this;
      if (Array.isArray(data)) {
        data.forEach(item => {
          _this.$set(item, "expand", val);
          if (item.children) {
            _this.toggleExpand(item.children, val);
          }
        });
      } else {
        this.$set(data, "expand", val);
        if (data.children) {
          _this.toggleExpand(data.children, val);
        }
      }
    },

    onNodeClick(e, data) {
      this.selectedNode = data;
      switch (this.selectedNodeType) {
        case constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANH_NODE:
          this.$emit("openVbIncomingFlow", data);
          break;
        default:
          this.isOpen = true;
          break;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/vbdi-luongxuly-mixin.js